import { colors } from "@mui/material";

const buildGradient = (start, end) =>
  `linear-gradient(180deg, ${start} 0%, ${end} 100%)`;

const grey = buildGradient(colors.grey[400], colors.grey[600]);
const blue = buildGradient(colors.blue[700], colors.blue[900]);
const indigo = buildGradient(colors.indigo[400], colors.indigo[600]);
const green = buildGradient(colors.green[400], colors.green[600]);
const orange = buildGradient(colors.orange[400], colors.orange[700]);
const red = buildGradient(colors.red[500], colors.red[700]);
const pink = buildGradient(colors.pink[500], colors.pink[700]);
const yellow = buildGradient(colors.yellow[500], colors.yellow[700]);
const Custom = `linear-gradient(90deg, #31343B 0%, #31343B 100%)`;
const Btn = `linear-gradient(90deg, #D59D03 0%, #31343B 100%)`;

const cApU = `linear-gradient(180deg, #0F111C 0%, #0F111C 100%)`
const cAp = `linear-gradient(180deg, #fff 0%, #fff 100%)`
export default {
  grey,
  blue,
  indigo,
  green,
  orange,
  red,
  pink,
  yellow,
  Custom,
  cAp,
  cApU
};